import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "~/src/App";

const element = document.getElementById("root");

if (!element) throw new Error("root element is not found.");

createRoot(element).render(
  <StrictMode>
    <App />
  </StrictMode>
);
